
var Toast = require('app/ui/Toast');

class Notification {

	defaultOptions(){
		return {
			'delay': 3000,//delay in ms or 'permanent'
			'type': 'info',//success,info,warning,danger (bootstrap colors)
			'message': '',
		};
	}

	constructor(options){
		this.settings = $.extend(this.defaultOptions(),options);

		// initialize attributes
		//this.$example = $('.class',this.$container);

		// bind events methods
		//this.onEvent = this.onEvent.bind(this);
		this.onShow = this.onShow.bind(this);
		this.onHide = this.onHide.bind(this);
		this.type = this.settings.type;
		switch(this.type){
			case 'error':
				this.type = 'danger';
			break;
			default:
			//do nothing
			break;
		}

		// initalize object
		this.initialize();
	}

	initialize(){

		this.$message = $('<div/>')
		.addClass('text-center')
		.append(this.settings.message);

		var parameters = {
			'onShow': this.onShow,
			'onHide': this.onHide,
			'position': 'top',

			'toastClass': 'notification notification-'+this.type,
			'bodyContent': this.$message,

			'showHeader': false,
			'showBody': true,
		};

		if(this.settings.delay == 'permanent'){
			parameters['autohide'] = false;
		}else{
			parameters['delay'] = this.settings.delay;
		}

		this.toast = new Toast(parameters);

		this.toast.show();
	}

	onShow(event){
		//
	}

	onHide(event){
		this.toast.dispose();
	}


}

module.exports = Notification;